import { useCellIsEditing, useCellIsReadOnly } from '../../cell.hooks'

import { SelectColumnCellEditor } from './SelectColumnCellEditor'
import { SelectColumnCellPreview } from './SelectColumnCellPreview'

/**
 * Renders a Cell inside a Column of type `select`.
 *
 * It can either render a select menu or select options editor.
 */
export function SelectColumnCell() {
  const isEditing = useCellIsEditing()
  const isReadOnly = useCellIsReadOnly()

  if (isEditing && !isReadOnly) {
    return <SelectColumnCellEditor />
  }

  return <SelectColumnCellPreview />
}
